import { c as _c } from "react/compiler-runtime";
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { SvgIconComponent } from '@mui/icons-material';
const ToolIcon: SvgIconComponent = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z" fill="currentColor" /><path d="M21.01 12.9737H19.23V12.0368C19.23 11.5169 18.8339 11.1 18.34 11.1H16.56C16.066 11.1 15.67 11.5169 15.67 12.0368V12.9737H13.89C13.396 12.9737 13.0044 13.3906 13.0044 13.9105L13 19.0631C13 19.5831 13.396 20 13.89 20H21.01C21.5039 20 21.9 19.5831 21.9 19.0631V13.9105C21.9 13.3906 21.5039 12.9737 21.01 12.9737ZM18.34 12.9737H16.56V12.0368H18.34V12.9737Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M11.2936 13.0503C11.115 13.2302 11.0047 13.4848 11.0047 13.7684L11 19.2105C11 19.534 11.1452 19.8198 11.3711 20L2 20V17.35C2 16.32 2.51 15.34 3.39 14.82C5.32 13.67 7.58 13 10 13C10.4959 13 10.924 13.0193 11.2936 13.0503Z" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
ToolIcon.muiName = 'custom-tool-icon';
export default ToolIcon;